import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface GatewayType {
  asset_type_id: string
  asset_type_name: string
  category_type_id: string
  category_type_name: string
}

export interface GatewayTypeState {
  isLoading: boolean
  loadingError: string | null
  gatewayType: GatewayType[] | null
  httpStatus: number | null
}

export const initialState: GatewayTypeState = {
  isLoading: true,
  loadingError: null,
  gatewayType: null,
  httpStatus: null
}

const gatewayTypeSlice = createSlice({
  name: 'gatewayManagementGatewayType',
  initialState,
  reducers: {
    gatewayTypeLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        gatewayType: null,
        httpStatus: 0
      }
    },
    gatewayTypeUpdateAction: (state, action: PayloadAction<{ data: GatewayType[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        gatewayType: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    gatewayTypeErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        gatewayType: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  gatewayTypeLoadingAction,
  gatewayTypeUpdateAction,
  gatewayTypeErrorAction
} = gatewayTypeSlice.actions

export default gatewayTypeSlice.reducer
